export enum CallStage {
  CURRENT = "Current",
  PAST = "Past",
  CURRENT_OR_PAST = "Current or Past",
}
